function NotFound() {
  return (
    <main>
      <div className="nav-gap"></div>
      <div class="not-found-404">
          <h1 className="center">404 Not Found</h1>
      </div>
    </main>
  );
}

export default NotFound;
